export { default } from "./ShippingDetails";
